var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CaKpiCards',{attrs:{"cards":_vm.cards,"columns":5}})
}
var staticRenderFns = []

export { render, staticRenderFns }